import request from 'superagent';
import { NEW_API_BASE_URL } from 'Common/constants';
import { delay } from 'Common/utils';

export function fakeSubmitApplication(value) {
  console.log('Submitting harassment message', value);
  return delay(500).then(() => ({
    ok: true,
    body: {
      code: 200,
      status: true,
      message: 'success',
      result: {
        request_id: '40227-s/22',
        token: '84ad92ab8c',
      },
    },
  }));
}

export function submitApplication(formVal, errorCb) {
  const url = `${NEW_API_BASE_URL}/request/send-request`;
  const req = request.post(url).send(formVal).on('error', errorCb);
  return req;
}

const getApi = () => {
  if (process.env.NODE_ENV === 'production') {
    return {
      submitApplication,
    };
  } else {
    return {
      submitApplication: fakeSubmitApplication,
    };
  }
};

export const Api = getApi();
export default getApi;



// WEBPACK FOOTER //
// ./src/apps/harassment-message/api.js